import { post } from "@insite/client-framework/Services/ApiService";
import { BrandFormModel } from "@tCooneyBrothers/ApiModels";

const customContactUsUrl = "api/v2/emailnew";

export function addBrandFormFields(parameter: BrandFormModel) {
    return post<BrandFormModel>(customContactUsUrl, parameter);
}
